import React from 'react';

const ResultPage: React.FC = () => {
  return (
    <div>
      테스트 결과 페이지
    </div>
  );
};

export default ResultPage;

